import { Tween } from '../../utils';
import { Sprite } from 'pixi.js';

const DURATION = 100;
const NUM_SHAKES = 3;
export class Quake
{
    private tween: Tween<Quake>;
    private target: Sprite;
    private _shake: number;
    private startPos: number;
    private dir: 'x'|'y';

    constructor(target: Sprite)
    {
        this.target = target;
        this._shake = 0;
        this.dir = Math.random() < 0.5 ? 'x' : 'y';
        this.startPos = target[this.dir];
        this.tween = Tween.get(this);
        const MOVEMENT = this.dir === 'x' ? 50 : 25;
        for (let i = 0; i < NUM_SHAKES; ++i)
        {
            this.tween.to({shake: MOVEMENT}, DURATION, 'bounceInOut');
            this.tween.to({shake: -MOVEMENT}, DURATION * 2, 'bounceInOut');
        }
        this.tween.to({shake: 0}, DURATION, 'bounceInOut');
    }

    public get shake() { return this._shake; }
    public set shake(val: number)
    {
        this._shake = val;
        this.target[this.dir] = this.startPos + val;
    }

    public dispose()
    {
        if (!this.tween) return;
        this.tween.destroy();
        this.tween = null;
        this.target = null;
    }
}